import React, { useEffect, useState, useImperativeHandle,useContext } from "react";
import { Container, Col, Row, Table } from "react-bootstrap";
import { format ,parseISO } from 'date-fns'
// import "./../PriceHistory.css";
import URLstateContext from "../../../provider/CommonContext";
function PriceHistory(props,ref) {

    let getExchange = props.exchange;
    //  console.log("ExchgVal"+getExchange);
    let getCoCode = props.coCode;
    // console.log("getCoCode"+getCoCode);


//   let getcompname = props.compname;
  let getData, getchartData;
  const [chartdata, setchartData] = useState([]);
  const {BaseURL} = useContext(URLstateContext);
  useImperativeHandle(ref, () => ({
      chnageexchnagepricehistory: (getExchange) => {
      
       const getUrlchart = BaseURL + "Company-Chart/";
         fetch(`${getUrlchart}/${getExchange}/${getCoCode}/5D`)
        .then((response) => response.json())
        .then((data) => {
          getchartData = data.data;
          setchartData(getchartData);        
        })
        .catch((error) => {
          //console.log("not found the api");
        }); 
        
    }
  }));
    useEffect(() => {
        // console.log("price cocode:" + props.coCode);
        // console.log("price name:" + props.compname);
    const getUrlchart = BaseURL +"PeerComparison/";
        if (getCoCode != "") {
            fetch(`${getUrlchart}/${getExchange}/${getCoCode}`)
                .then((response) => response.json())
                .then((data) => {
                    getchartData = data.data;
                    setchartData(getchartData);

                })
                .catch((error) => {
                    //console.log("not found the api");
                });
        }
      

  }, [props.coCode, props.exchange]);
  return (
    <>
      <section className="price-history-section ">
        <Container className="table-boxPrice">
          <Row>
            <Col md={12}>
              <h4> Peer Comparison </h4>
              <div className="table-responsive">
              <Table striped bordered hover size="sm">
              <thead className='heading'>

<tr>
    <th scope="col">Company Name</th>
    <th scope="col">PRICE<span className="muted">(Rs.)</span></th>
    <th scope="col">MCAP<span className="muted">(Cr.)</span></th>
    <th scope="col">P/B</th>
    <th scope="col">P/E<span className="muted">(Rs.)</span></th>
    <th scope="col">EPS<span className="muted">(%)</span></th>
    <th scope="col">ROE<span className="muted">(%)</span></th>
    <th scope="col">ROCE<span className="muted">(%)</span> </th>
    <th scope="col">P/S</th>
    <th scope="col">EV/EBITDA</th>

</tr>

</thead>
                {(chartdata === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                <tbody >
               
                  {chartdata && chartdata.map(({ co_code, lname, currprice, mcap, Price_BookValue, PriceEarning, PATMargin, EPS, P_S, ROE, ROCE, EV_EBITDA }) => (
                      <>
                         <tr className="SameCompPeer ">
                                                <td><h6 className="forhover">{lname} </h6></td>
                                                
                                                <td> {(currprice != null) ? currprice.toFixed(2) : currprice = 0}</td>
                                                {/* <td className="Number">{currprice.toFixed(2)}</td> */}
                                                {/* <td className="Number">{mcap.toFixed(2)}</td>
                                    <td className="Number">{Price_BookValue.toFixed(2)}</td>
                                    <td className="Number">{PriceEarning.toFixed(2)}</td>
                                    <td className="Number">{EPS.toFixed(2)}</td>
                                    <td className="Number">{ROE.toFixed(2)}</td>
                                    <td className="Number">{ROCE.toFixed(2)}</td>
                                    <td className="Number">{P_S.toFixed(2)}</td>
                                    <td className="Number">{EV_EBITDA.toFixed(2)}</td> */}
                                                <td> {(mcap != null) ? mcap.toFixed(2) : mcap = 0}</td>
                                                <td> {(Price_BookValue != null) ? Price_BookValue.toFixed(2) : Price_BookValue = 0}</td>
                                                <td> {(PriceEarning != null) ? PriceEarning.toFixed(2) : PriceEarning = 0}</td>
                                                <td> {(EPS != null) ? EPS.toFixed(2) : EPS = 0}</td>
                                                <td> {(ROE != null) ? ROE.toFixed(2) : ROE = 0}</td>
                                                <td> {(ROCE != null) ? ROCE.toFixed(2) : ROCE = 0}</td>
                                                <td> {(P_S != null) ? P_S.toFixed(2) : P_S = 0}</td>
                                                <td> {(EV_EBITDA != null) ? EV_EBITDA.toFixed(2) : EV_EBITDA = 0}</td>

                                            </tr>
                      </>
                    ))}
                </tbody>
              </Table>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default React.forwardRef(PriceHistory);